import { AxiosResponse } from 'axios'
import api from './api'

type ResendVerificationEmailParams = {
  email: string
}
const resendVerificationEmail = (params: ResendVerificationEmailParams): Promise<AxiosResponse> => {
  return api.post('/v1/email-verification/resend-verification-email', { email: params.email }, {})
}

type VerifyEmailParams = {
  email: string
  code: string
}
const verifyEmail = (params: VerifyEmailParams): Promise<AxiosResponse> => {
  return api.post('/v1/email-verification/verify', { email: params.email, code: params.code }, {})
}

export default {
  resendVerificationEmail,
  verifyEmail,
}
